import { AppRouter } from "./router";

function App() {
  return (
    <div className="min-h-screen bg-background">
      <AppRouter />
    </div>
  );
}

export default App;
